import { combineReducers } from "redux";
import authReducer from "./auth.reducer";
import RiderReducer from "./rider.reducer";
import BatchReducer from "./batch.reducer";
import ZoneReducer from "./zone.reducer";
import ShiftReducer from "./shift.reducer";
import OrderManagementReducer from "./orderManagement.reducer";
import OrderManagementFilterReducer from "./orderManagementFilters.reducer";
import OrderManagementNewReducer from "./orderManagementNew.reducer";
import OrderManagementListingReducer from "./orderManagementListing.reducer";
import WalletIssueReducer from "./walletIssue.reducer";
import DashboardReducer from "./dashboard.reducer";
import PermissionReducer from "./permission.reducer";
import BreakReducer from "./break.reducer";
import DispactherNoteReducer from "./dispactherNote.reducer";
import CancellationReasonReducer from "./cancellationReason.reducer";
import PerformanceReducer from "./performance.reducer";
import NotificationReducer from "./notification.reducer";
import IssuesReducer from "./issues.reducer";
import CancelledOrderReducer from "./cancelledOrder.reducer";
import PickerPakerPageReducer from "./pickerPakerPage.reducer";
import MartHealthDashboardReducer from "./martHealthDashboard.reducer";
import TriggersReducer from "./triggers.reducer";
import UnRegisterRiderReducer from "./unRegisterRider.reducer";
import SiteConfigReducer from "./site.config.reducer";
import TaskInvoiceReducer from "./task.invoice.reducer";
import WorkReducer from "./work.reducer";

// import invoiceReducer from "./invoice.reducer";

const rootReducer = combineReducers({
  authReducer,
  RiderReducer,
  BatchReducer,
  ZoneReducer,
  ShiftReducer,
  OrderManagementReducer,
  OrderManagementFilterReducer,
  OrderManagementNewReducer,
  OrderManagementListingReducer,
  WalletIssueReducer,
  DashboardReducer,
  PermissionReducer,
  BreakReducer,
  DispactherNoteReducer,
  CancellationReasonReducer,
  PerformanceReducer,
  NotificationReducer,
  IssuesReducer,
  SiteConfigReducer,
  CancelledOrderReducer,
  PickerPakerPageReducer,
  TriggersReducer,
  //   invoiceReducer,
  MartHealthDashboardReducer,
  UnRegisterRiderReducer,
  TaskInvoiceReducer,
  WorkReducer,
});

export default rootReducer;
